export const logAction = (op, id) => {
  const ukey = sessionStorage.getItem("ukey");
  if (ukey) {
    fetch("https://www.energymarketprice.com/hedgesnew/server/api/logs", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        Operation: op,
        ID: id,
        CockitKey: "9C3959D1-5CAB-43C8-A03E-92E08C11F1F0",
        UserKey: ukey,
      }),
    });
  }
};
